<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gvwPkC/tc-custom/9783988269126.jpg?1704453169960" alt="This image is the cover for the book Nationalism & Letters, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nationalism & Letters, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Nationalism is a collection of essays written by Rabindranath Tagore, the renowned Indian poet, philosopher, and Nobel laureate. The book is a compilation of Tagore's thoughts and reflections on the concept of nationalism and its implications on society, culture, and the individual. Tagore's views on nationalism were a response to the prevalent political and social climate during his time, and his critique remains influential and relevant today. "Letters" by Rabindranath Tagore typically refers to a compilation of the letters written by Tagore over his lifetime. Rabindranath Tagore, a prolific writer, poet, philosopher, and Nobel laureate, maintained extensive correspondence with a diverse range of people, including family members, friends, intellectuals, political leaders, and artists. These letters provide valuable insights into Tagore's thoughts, personal life, literary works, and his views on various social and political issues of his time.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rabindranath Tagore
      </h2>
      
      <p class="authorDescription body article">Rabindranath Tagore, also known as Rabindranath Thakur, was a highly revered and influential Indian poet, philosopher, writer, musician, and artist. He is best known for his poetry and for composing the national anthems of India ("Jana Gana Mana") and Bangladesh ("Amar Shonar Bangla"). Tagore's contributions to literature, music, and the arts earned him international acclaim, and he became the first non-European to win the Nobel Prize in Literature in 1913.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40605bbc